import React, { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  setPaymentPending,
  getFullToken
} from "./ducks/actions";
import PaymentComplete from "./complete";

function PaymentCompleteContainer(props) {
  const {
    setPaymentPending,
    getFullToken,
    errors,
    paymentComplete,
    paid
  } = props;

  useEffect(() => {
    setPaymentPending();
  }, []);

  useEffect(() => {
    if (paymentComplete) {
      getFullToken();
    }
  }, [paymentComplete]);

  return (
    <PaymentComplete errors={errors} paid={paid} />
  );
}

function mapStateToProps(state) {
  const { accountState } = state;
  const { paymentState } = accountState;
  return {
    errors: paymentState.errors,
    paymentComplete: paymentState.paymentComplete,
    paid: paymentState.paid
  };
}

export default connect(mapStateToProps, {
  setPaymentPending,
  getFullToken
})(PaymentCompleteContainer);
